import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FAQ() {
  const [openId, setOpenId] = useState<string>('faq1');

  const toggle = (id: string) => {
    setOpenId(openId === id ? '' : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-12">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqData.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <i
                    className={`flex-shrink-0 w-4 h-4 flex items-center justify-center text-foreground-500 transition-transform duration-200 ${
                      isOpen ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}